export const checkoutUrl = 'https://visuelleratlas.impultienda.ar'

export const seo = {
  lang: 'de-DE',
  title: '100 Übungsübersichten + 6 Praxispakete für Trainer',
  description:
    '100 visuelle Übungsübersichten, 24 anpassbare Trainingseinheiten und 6 Praxispakete für Personal Trainer. Digital als PDF. Einmalig 19 €.',
}

export const brand = {
  eyebrow: 'Für Personal Trainer und Fitnesstrainer',
  headline: '100 Übungen, bereits analysiert.',
  headlineAccent: 'Spare dir langes Suchen in Videos und Fachbüchern.',
  name: 'Visueller Atlas der Trainingsbiomechanik',
  subheadline: '100 visuelle Übungsübersichten + 6 Praxispakete',
  description:
    '100 fertige Übungserklärungen, 24 anpassbare Trainingseinheiten und Korrekturhinweise zu 50 typischen Technikfehlern. Alles an einem Ort, damit du weniger vorbereiten musst und Übungen verständlicher erklären kannst.',
  tagline: 'Auswählen. Nachschlagen. Verständlich erklären.',
}

export const heroCta = 'Jetzt kompletten Atlas sichern'

export const heroNote = 'Sofortiger Zugang · Druckbare PDFs · Einmalzahlung'

export const heroGuarantee = 'Inklusive zusätzlicher 7-Tage-Geld-zurück-Garantie'

export const heroImageAlt =
  'Visueller Atlas der Trainingsbiomechanik mit 100 Übungsübersichten und 6 Praxispaketen'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '100', label: 'Visuelle Übungsübersichten' },
  { value: '100', label: 'Analysierte Übungen' },
  { value: '3', label: 'Trainingsbereiche' },
  { value: '6', label: 'Praxispakete' },
]

export interface Situation {
  title: string
  text: string
}

export const situationsTitle = 'Kommt dir das aus deinem Traineralltag bekannt vor?'

export const situationsIntro =
  'Wenn du Kunden beim Training betreust, kennst du wahrscheinlich mindestens eine dieser Situationen.'

export const situations: Situation[] = [
  {
    title: 'Ein Kunde fragt, welche Muskeln bei einer Übung arbeiten.',
    text: 'Du kennst die Übung. Aber auf Anhieb verständlich zu erklären, welche Muskeln dabei welche Aufgabe übernehmen, ist nicht immer leicht.',
  },
  {
    title: 'Du erkennst einen Technikfehler, findest aber nicht die richtigen Worte.',
    text: 'Du möchtest die Bewegung genauer einordnen und deinem Kunden klar erklären, worauf er bei der Ausführung achten soll.',
  },
  {
    title: 'Du suchst dieselben Informationen immer wieder.',
    text: 'Ein Video hier, ein Fachbuch dort, dazu eigene Notizen. Wenn du eine Übung nachschlagen willst, kostet dich das jedes Mal Zeit.',
  },
  {
    title: 'Du kennst die Theorie. Der Bezug zur Praxis braucht Zeit.',
    text: 'Muskeln, Gelenkbewegungen und Bewegungsebenen mit einer konkreten Übung zu verbinden, ist im Trainingsalltag nicht immer sofort möglich.',
  },
]

export const situationsClosing =
  'Ein übersichtliches Nachschlagewerk hilft dir, dein Wissen genau dann zu nutzen, wenn du es brauchst.'

export const comparisonCopy = {
  title: 'Aus verstreuten Informationen werden 100 übersichtliche Übungsanalysen.',
  oldEyebrow: 'Vorher',
  oldLabel: 'Ohne den Atlas',
  atlasEyebrow: 'Nachher',
  atlasLabel: 'Mit dem visuellen Atlas',
  closing: 'Weniger suchen. Mehr Zeit für deine Kunden.',
}

export const comparisonOld: string[] = [
  'Du suchst Erklärungen in verschiedenen Videos und Fachbüchern.',
  'Deine Notizen zu Muskeln und Bewegungen liegen an unterschiedlichen Stellen.',
  'Du brauchst Zeit, um dieselben Informationen wiederzufinden.',
  'Du musst die Verbindung zwischen Theorie und Übung selbst herstellen.',
]

export const comparisonAtlas: string[] = [
  '100 Übungen sind bereits analysiert und übersichtlich aufbereitet.',
  'Muskeln, Bewegung und Ausführung stehen auf einer Übersicht.',
  'Häufige Fehler und praktische Hinweise sind schnell nachzuschlagen.',
  'Anatomisches Wissen wird direkt mit konkreten Übungen verknüpft.',
]

export interface DemoStep {
  number: string
  title: string
  text: string
}

export const demoCopy = {
  title: 'Dein Kunde fragt. Du hast die Übungsanalyse griffbereit.',
  questionLabel: 'Ein Kunde möchte wissen:',
  question: 'Welche Muskeln trainiere ich bei Kniebeugen?',
}

export const demoSteps: DemoStep[] = [
  {
    number: '01',
    title: 'Auswählen',
    text: 'Öffne den Bereich Unterkörper und rufe die Übersicht zur Kniebeuge auf.',
  },
  {
    number: '02',
    title: 'Nachschlagen',
    text: 'Schau dir die beteiligten Muskeln, die Ausführung und typische Fehler an.',
  },
  {
    number: '03',
    title: 'Erklären',
    text: 'Nutze die Übersicht, um deinem Kunden die Bewegung und die beteiligten Muskeln verständlich zu erklären.',
  },
]

export const galleryCopy = {
  title: 'So sehen die Übungsübersichten aus.',
  subtitle:
    'Konkrete Übungen, anschaulich analysiert – mit den wichtigsten Informationen auf einen Blick.',
  footer: '100 analysierte Übungen. Ein Atlas zum schnellen Nachschlagen.',
  cta: 'Ich möchte die 100 Übungsübersichten',
  carouselRole: 'Karussell',
  carouselLabel: 'Galerie der Übungsübersichten',
  prevLabel: 'Vorherige Übersicht',
  nextLabel: 'Nächste Übersicht',
}

export interface GalleryItem {
  title: string
  caption: string
  image: string
}

export const gallery: GalleryItem[] = [
  {
    title: 'Langhantel-Kniebeuge',
    caption:
      'Hauptmuskeln, Stabilisatoren, Bewegungsebene und typische Fehler – übersichtlich auf einer Seite.',
    image:
      'https://cdn.magicpatterns.com/uploads/5PMEYqKK1eKoFuGFxj7K4e/Captura_de_pantalla_2026-10-21_a_la(s)_11.20.13_p._m..png',
  },
  {
    title: 'Bulgarische Kniebeuge',
    caption:
      'Einbeiniges Training: was stabilisiert, was ausgleicht und wie du die Ausführung korrigierst.',
    image:
      'https://cdn.magicpatterns.com/uploads/vqDoYU3w1yP368Dq4iV4Z9/Captura_de_pantalla_2026-10-21_a_la(s)_11.27.44_p._m..png',
  },
  {
    title: 'Schrägbankdrücken mit Langhantel',
    caption:
      'Schlüsselbeinanteil des großen Brustmuskels, Rotatorenmanschette und korrekte Bewegungsbahn der Langhantel.',
    image:
      'https://cdn.magicpatterns.com/uploads/4XfuqhmtymK95R2JgUZGNq/Captura_de_pantalla_2026-10-21_a_la(s)_11.22.07_p._m..png',
  },
  {
    title: 'Kabelzug-Fliegende von unten',
    caption:
      'Horizontale Adduktion in einer schrägen Bewegungsebene und Kontrolle der Spannung in der Brustmuskulatur.',
    image:
      'https://cdn.magicpatterns.com/uploads/py92nf239moczK9c4NQ8ot/Captura_de_pantalla_2026-10-21_a_la(s)_11.25.04_p._m..png',
  },
  {
    title: 'Langhantelrudern',
    caption:
      'Schulterblattretraktion, hintere Muskelkette und warum Schwung die Übung verfälscht.',
    image:
      'https://cdn.magicpatterns.com/uploads/xwS5ckbDDj6CApzQdiNxVY/Captura_de_pantalla_2026-10-21_a_la(s)_11.23.00_p._m..png',
  },
]

export const systemCopy = {
  title: '100 Übungen, bereits für dich analysiert.',
  subtitle:
    'Ein visuelles Nachschlagewerk mit drei Trainingsbereichen – damit du die passende Übung schnell findest.',
  categoryLabel: 'Bereich',
  includesTitle: 'Das findest du auf jeder Übungsübersicht:',
  closing:
    'Dein visuelles Nachschlagewerk, um Übungen besser zu verstehen und verständlich zu erklären.',
}

export interface Module {
  number: string
  title: string
  detail: string
  summary: string
  description: string
  spine: string
}

export const modules: Module[] = [
  {
    number: '01',
    title: 'Unterkörper',
    detail: 'Übungen für Beine und Gesäß',
    summary:
      'Kniebeugen, Kreuzheben, Hip Thrusts, Ausfallschritte, Beinpresse und verschiedene Übungsvarianten.',
    description:
      'Beteiligte Muskeln, Ausführung und typische Fehler bei wichtigen Übungen für den Unterkörper.',
    spine: 'bg-blue-400',
  },
  {
    number: '02',
    title: 'Oberkörper',
    detail: 'Drück- und Zugbewegungen',
    summary: 'Bankdrücken, Liegestütze, Klimmzüge, Rudern, Latzug und Isolationsübungen.',
    description:
      'Anschauliche Analysen wichtiger Drück- und Zugbewegungen für Brust, Rücken, Schultern und Arme.',
    spine: 'bg-blue-600',
  },
  {
    number: '03',
    title: 'Rumpf, Stabilität & Ganzkörper',
    detail: 'Stabilität und Bewegungskontrolle',
    summary:
      'Planks, Dead Bugs, Bird Dogs sowie weitere Übungen für Rumpfstabilität und Ganzkörpertraining.',
    description: 'Beteiligte Muskeln, Stabilisation und wichtige Details zur Bewegungsausführung.',
    spine: 'bg-blue-900',
  },
]

export const mapIncludes: string[] = [
  'Hauptmuskeln und unterstützende Muskeln',
  'Stabilisierende Muskulatur',
  'Gelenkbewegungen und Bewegungsebenen',
  'Hinweise zur Ausführung',
  'Häufige Technikfehler',
  'Praktische Trainingstipps',
]

export interface Bonus {
  tag: string
  title: string
  benefit: string
}

export const bonusesCopy = {
  title: 'Dazu erhältst du 6 Praxispakete.',
  subtitle: 'Ergänzende Hilfen, um Übungen zu analysieren, zu wiederholen und zu erklären.',
  badge: 'Inklusive',
  closing: 'Alle 6 Praxispakete sind bereits in deinem Atlas enthalten.',
}

export const bonuses: Bonus[] = [
  {
    tag: 'Praxispaket 01',
    title: 'Leitfaden gegen Blockaden',
    benefit: 'Praktische Schemata, um Übungen klar und strukturiert zu erklären.',
  },
  {
    tag: 'Praxispaket 02',
    title: '7-Tage-Ablauf',
    benefit: 'Ein strukturierter Ablauf, um die Analyse von Übungen zu festigen.',
  },
  {
    tag: 'Praxispaket 03',
    title: 'Wiederholungsplan',
    benefit: 'Wiederholungsschemata für 7 Tage, 3 Tage und 24 Stunden.',
  },
  {
    tag: 'Praxispaket 04',
    title: '60-Sekunden-Checkliste',
    benefit: 'Ein schneller Ablauf, um jede Übung methodisch zu analysieren.',
  },
  {
    tag: 'Praxispaket 05',
    title: 'Praxisheft',
    benefit: '20 Übungen mit Beispielen für Analyse und Erklärung.',
  },
  {
    tag: 'Praxispaket 06',
    title: 'Kompaktes Glossar',
    benefit: 'Muskeln, Bewegungen und Bewegungsebenen einfach erklärt.',
  },
]

export interface Testimonial {
  initials: string
  quote: string
  author: string
  role: string
  city?: string
}

export const testimonialsCopy = {
  eyebrow: 'Erfahrungsberichte',
  title: 'Das sagen Menschen, die den Atlas nutzen',
  starsLabel: '5 von 5 Sternen',
}

export const testimonials: Testimonial[] = [
  {
    initials: 'GR',
    quote:
      'Ich kannte schon viele Inhalte, konnte sie aber schwer mit den Übungen verbinden. Sie visuell erklärt zu sehen, hat mir geholfen, viel besser zu verstehen, was bei jeder Bewegung passiert.',
    author: 'Giulia R.',
    role: 'Studentin der Sportwissenschaft',
  },
  {
    initials: 'ML',
    quote:
      'Ich nutze ihn vor allem, wenn ich eine Übung schnell nachschlagen möchte. Mir gefällt, dass ich die beteiligten Muskeln, die Bewegung und typische Fehler sofort finde, ohne in unzähligen Notizen zu suchen.',
    author: 'Marco L.',
    role: 'Personal Trainer',
  },
  {
    initials: 'EF',
    quote:
      'Ich hatte vor der Prüfung wenig Zeit zum Wiederholen, und die Übersichten haben mir geholfen, Ordnung zu schaffen. Manche Themen, die mir in Büchern unklar erschienen, wurden deutlich verständlicher.',
    author: 'Elisa F.',
    role: 'Studentin',
  },
]

export const guaranteeCopy = {
  title: 'Deine zusätzliche 7-Tage-Geld-zurück-Garantie',
  paragraphs: [
    'Schau dir die Übungsübersichten an und lerne die enthaltenen Materialien kennen.',
    'Wenn du innerhalb von 7 Tagen nach dem Kauf feststellst, dass der Atlas nicht zu deinen Bedürfnissen passt, kannst du gemäß den Garantiebedingungen eine Rückerstattung beantragen. Deine gesetzlichen Rechte bleiben unberührt.',
  ],
  closing: 'Einmal zahlen. Kein Abo. Dauerhaft nutzen.',
}

export interface FaqItem {
  question: string
  answer: string
}

export const faqTitle = 'Häufige Fragen'

export const faqs: FaqItem[] = [
  {
    question: 'Ist der Atlas auch für Trainer geeignet, die gerade erst anfangen?',
    answer:
      'Ja. Die Übungsübersichten helfen dir, anatomisches Wissen mit konkreten Übungen zu verbinden. Du kannst sie zur Vorbereitung deiner Einheiten nutzen oder gezielt nachschlagen, wenn du eine Bewegung noch einmal durchgehen möchtest.',
  },
  {
    question: 'Kann ich den Atlas während des Trainings auf dem Smartphone nutzen?',
    answer:
      'Ja. Die PDFs lassen sich auf dem Smartphone, Tablet oder Computer öffnen. So kannst du eine Übungsübersicht auch zwischen zwei Übungen aufrufen. Für eine größere Darstellung kannst du ein Tablet nutzen oder die gewünschte Seite ausdrucken.',
  },
  {
    question: 'Sind fertige Trainingspläne enthalten?',
    answer:
      'Nein. Es handelt sich um ein visuelles Nachschlagewerk zur Analyse von Übungen, nicht um eine Sammlung individueller Trainingspläne.',
  },
  {
    question: 'Kann ich die Übungsübersichten ausdrucken?',
    answer:
      'Ja. Die Materialien sind als druckbare PDFs enthalten. Du kannst einzelne Seiten oder die gesamte Sammlung ausdrucken und für deine Trainingsvorbereitung nutzen.',
  },
  {
    question: 'Wie erhalte ich die Materialien? Gibt es ein Abo?',
    answer:
      'Nach erfolgreicher Zahlung erhältst du digitalen Zugang zu den Materialien. Du zahlst einmalig 19 € und kannst die PDFs herunterladen und dauerhaft nutzen. Es gibt kein Abo und keine monatlichen Gebühren.',
  },
  {
    question: 'Was passiert, wenn der Atlas nicht zu meinen Bedürfnissen passt?',
    answer:
      'Du kannst innerhalb von 7 Tagen nach dem Kauf gemäß den Bedingungen der zusätzlichen Geld-zurück-Garantie eine Rückerstattung beantragen. Deine gesetzlichen Rechte bleiben unberührt.',
  },
]

export interface Offer {
  title: string
  name: string
  summary: string
  includes: string[]
  price: string
  currency: string
  cta: string
  note: string
}

export const offer: Offer = {
  title: 'Dein kompletter visueller Atlas. Alles in einem Kauf.',
  name: 'Visueller Atlas der Trainingsbiomechanik',
  summary: '100 visuelle Übungsübersichten + 6 Praxispakete',
  includes: [
    '100 bereits analysierte Übungen',
    'Übungen für den Unterkörper',
    'Übungen für den Oberkörper',
    'Übungen für Rumpf, Stabilität & Ganzkörper',
    'Muskeln, Ausführung und typische Fehler',
    'Alle 6 Praxispakete inklusive',
    'Druckbare PDFs',
    'Sofortiger und dauerhafter Zugang',
  ],
  price: '19',
  currency: '€',
  cta: 'Ja, ich möchte den kompletten Atlas',
  note: 'Einmalzahlung · Kein Abo · 7-Tage-Geld-zurück-Garantie',
}

export const finalCtaCopy = {
  title: '100 bereits analysierte Übungen. Griffbereit, wenn du sie brauchst.',
  subtitle:
    'Schluss mit der Suche nach denselben Erklärungen. Muskeln, Ausführung und typische Fehler übersichtlich in einem visuellen Atlas.',
  summary: '100 visuelle Übungsübersichten + 6 Praxispakete',
  cta: 'Jetzt kompletten Atlas sichern',
}

export const finalCtaBadges = {
  access: 'Sofortiger Zugang',
  payment: 'Einmalzahlung',
  guarantee: '7-Tage-Geld-zurück-Garantie',
}

export const footerCopy = {
  name: 'Visueller Atlas der Trainingsbiomechanik',
  description:
    'Digitales Produkt · Sofortiger Zugang · Zusätzliche 7-Tage-Geld-zurück-Garantie',
  copyright: '© 2026 Visueller Atlas der Trainingsbiomechanik. Alle Rechte vorbehalten.',
  links: [
    { label: 'Allgemeine Geschäftsbedingungen', href: '#termini' },
    { label: 'Datenschutzerklärung', href: '#privacy' },
    { label: 'Kontakt', href: '#contatti' },
  ],
}

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/duWT23e1FaGBRYqRVgwXtb/image.png'
